import React, { useState } from "react";
import Future from "../images/future.png";
import Raise from "../images/raise.png";
import RaiseCapital from "../images/RaiseCapital.png";
import BuyArrow from "../images/buy.svg";
import Security from "../images/security.png";
import Token from "../images/token.png";
import { useEffect } from "react";
import "../styles/main.scss"
import LandingNav from "../components/landing-nav"
import { Helmet } from "react-helmet"
import Footer from "../components/footer"
import { getApi } from "../components/api/getApi";
import mautic from 'mautic-tracking';
import tokenizationOG from "../images/tokenizationOG.jpg"

// markup
const IndexPage = () => {
    const isBrowser = typeof window !== "undefined"
    let isLogined = false
    if (isBrowser) {
        isLogined = !!localStorage.getItem('token')
    }

    useEffect(() => {
        mautic.initialize('https://ams.solidblock.co/mtc.js')
        mautic.pageView({});
        const myId = window.location.hash.slice(1);
        const elem = document.getElementById(myId);
        if (elem) {
            elem.scrollIntoView();
        }
    }, [])
    const baseUrl = process.env.GATSBY_BASE_URL;

    function learnClick() {
        if (typeof window !== "undefined") {
            if (window.fbq != null) {
                window.fbq('track', 'AddToCard');
                window.location.href = `${baseUrl}/tokenization-form`;
            }
        }
    }

    return (
        <div className="main-tokenization">
            <Helmet>
                <title>Best Real Estate Tokenization - DIBS Capital</title>
                <meta name="description" content="DIBS Capital is creating compliant, secure tokenized real estate which can be traded like stocks and keeps investor capital liquid." />

                {/* Facebook Meta Tags */}
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Best Real Estate Tokenization - DIBS Capital" />
                <meta property="og:description" content="DIBS Capital is creating compliant, secure tokenized real estate which can be traded like stocks and keeps investor capital liquid." />
                <meta property="og:image" content={`${baseUrl}${tokenizationOG}`} />

                {/* Twitter Meta Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Best Real Estate Tokenization - DIBS Capital" />
                <meta name="twitter:description" content="DIBS Capital is creating compliant, secure tokenized real estate which can be traded like stocks and keeps investor capital liquid." />
                <meta name="twitter:image" content={`${baseUrl}${tokenizationOG}`} />


                <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&family=Montserrat:wght@400;500;700&display=swap" />

                {/* piperdrive start */}
                <script>
                    {`window.pipedriveLeadboosterConfig = {base: 'leadbooster-chat.pipedrive.com',companyId: 10839267,
                    playbookUuid: '58b7e12b-6dff-4da0-bf4b-be9865b46faf',version: 2};
                    (function () {var w = window;if (w.LeadBooster) {console.warn('LeadBooster already exists');} else {w.LeadBooster = {q: [],on: function (n, h)
                     {this.q.push({ t: 'o', n: n, h: h });},trigger: function (n) {this.q.push({ t: 't', n: n });},};}})();
                     `}
                </script>
                <script src="https://leadbooster-chat.pipedrive.com/assets/loader.js" async></script>
                {/* piperdrive end */}
                {/* <!-- Google Analytics -->  */}
                <script async src="https://www.googletagmanager.com/gtag/js?id=G-1YHPQK13C8"></script>
                <script async>
                    {`
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    dataLayer.push(arguments);
                }
                gtag('js', new Date());
                gtag('config', 'G-1YHPQK13C8');
                `}
                </script>
                {/* <!-- Start Google Tag Manager --> */}
                <script>
                    {`
                    (function(w,d,s,l,i){w[l] = w[l] || [];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','GTM-KLQWH2PL');
                    `}
                </script>
                {/* <!-- End Google Tag Manager --> */}

            </Helmet>
            <LandingNav />
            <main className="main text-page">
                <section className="section-tokenize-real-estate">
                    <div className="firstTokBlock">
                        <img src={RaiseCapital} alt="" />
                        <div className="tokRight">
                            <h1 className="tokSubTitle">
                                A to Z Tokenization
                            </h1>
                            <p className="tokDetails">
                                Learn how to sell assets or fund your next
                                <br />
                                project via web3-enabled securities
                            </p>
                            <div className="buttons">
                                <button className="tokStartBtn" onClick={learnClick}>
                                    Start Tokenization
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="tokWrapper">
                        <article className="text-article">
                            <p>
                                Real estate tokenization is an emerging trend representing the
                                convergence of real estate investing and blockchain technology.
                                Tokenization helps asset or fund owners raise capital more
                                efficiently, and gives investors unprecedented access to private
                                real estate investments, transparency, and liquidity.
                            </p>
                            <p>
                                In this article, we’ll explain what tokenization means, how
                                owners and investors can benefit, and how the tokenization
                                process works.
                            </p>
                        </article>
                        <article className="text-article">
                            <h2 className="tokSubTitle">
                                What does it mean to
                                <br />
                                “tokenize” a real estate asset?
                            </h2>
                            <p>
                                Tokenization is a relatively new term used to describe a
                                cryptocurrency fundraise in which investors exchange fiat or
                                crypto currency for “tokens”.
                            </p>
                            <p className="text--bold" id="securitization">
                                In a nutshell, tokenization is one way to securitize real
                                assets.
                            </p>
                            <p>
                                To securitize an asset means to divide it into shares that you
                                can sell to investors. In the same way, to “tokenize” an asset
                                is to divide it into shares, or “tokens”, that represent a
                                predefined share of the underlying asset. They are therefore
                                often called
                                <span className="text--bold"> “security tokens”</span>.
                            </p>
                            <p>
                                These tokens are secured through the immutability of blockchain
                                technology, and they’re tradeable via crypto exchanges or
                                Alternative Trading Systems (ATS).
                            </p>
                        </article>
                        <img src={Token} alt="" className="mainImg" />
                        <article className="text-article">
                            <h2 className="tokSubTitle">Creating a new real estate token</h2>
                            <p>
                                When an asset owner decides to tokenize a property, an
                                Ethereum-standard (ERC20)
                                <span className="text--bold"> real estate token</span>
                                (also called a
                                <span className="text--bold"> security token</span>) is created
                                to represent shares of the property. The total value of all
                                tokens will be equivalent to the total value of the securitized
                                asset. Let’s look at a simple example.
                            </p>
                            <p>
                                Suppose you want to tokenize a 100,000 sq ft property that’s
                                worth $30M. A simple way to divide the property into shares is
                                to offer one share for every square foot. So you would divide
                                the property into 100,000 shares, each representing one square
                                foot of the property and valued at $300.
                            </p>
                            <p>
                                Alternatively, you could divide the property into square inches,
                                in which case each token would be worth $2.08. You might choose
                                this option to make your project accessible to a wider range of
                                investors. Of course, you could also choose to limit the share
                                offering to a certain percentage of the asset – say 20%, to
                                retain majority ownership while raising funds for a new wing or
                                renovations, for example.
                            </p>
                            <p>The next step is to sell the tokens to investors.</p>
                        </article>
                    </div>
                    <div className="purpleWrapper">
                        <article className="text-article">
                            <img src={Raise} alt="" className="mainImg" />
                            <h2 className="tokSubTitle">Raise capital faster</h2>
                            <p className="tokCenterText">
                                Take the first step toward tokenizing your real estate assets
                                today and learn how to raise capital faster and reach more
                                investors.
                            </p>
                            <a href={`${baseUrl}/tokenization-form`}>
                                <button className="tokStartBtn">
                                    Start Here
                                    <img src={BuyArrow} alt="" />
                                </button>
                            </a>
                        </article>
                    </div>
                    <div className="tokWrapper">
                        <img src={Security} alt="" className="mainImg" />
                        <article className="text-article">
                            <h2 className="tokSubTitle" id="digitalization">
                                The security token offering (STO) process
                            </h2>
                            <p>
                                The initial sale of a security token is typically called a
                                <span className="text--bold">
                                    {" "}
                                    security token offering (STO)
                                </span>
                                . It’s also sometimes called a
                                <span className="text--bold">
                                    {" "}
                                    tokenized security offering (TSO)
                                </span>{" "}
                                or a
                                <span className="text--bold">
                                    {" "}
                                    tokenized asset offering (TAO)
                                </span>
                                . But no matter what term you use, the result is the same.
                            </p>
                            <div className="infoBox">
                                <div className="info-box__text">
                                    <p>

                                        Please note: An STO is
                                        not the same thing as an initial coin offering (ICO).
                                    </p>
                                </div>
                                <div className="info-box__text">
                                    <p>
                                        ICOs offer investors a token, but this token doesn’t
                                        necessarily represent ownership in the underlying asset or
                                        company. In many cases, the tokens sold are called “utility
                                        tokens” because they only have value on the company’s
                                        platform. Buyers are therefore “investing” to support the
                                        project and with the hope that, as the platform grows, the
                                        value of the tokens will increase.
                                    </p>
                                    <p>
                                        STOs are distinct from ICOs because the tokens sold
                                        (security tokens) represent ownership in a real asset. STO
                                        investors know the real value of the underlying asset
                                        they’re buying and benefit from any future price
                                        appreciation in the asset.
                                    </p>
                                </div>
                            </div>
                            <p>
                                Some asset owners choose to sell their tokens via a crowdfunding
                                campaign. For example, we worked with Indiegogo to launch the Aspen Coin, 
                                which represents fractional ownership in the St. Regis Aspen
                                Resort. This campaign successfully raised $18M.
                            </p>
                            <p>
                                Another option is for asset owners to market and sell their
                                tokens on their own. The best part about STOs is there’s no one
                                way to do them. Asset owners are in complete control of how they
                                want to market their STO.
                            </p>
                        </article>
                    </div>
                    <div className="purpleWrapper green">
                        <article className="text-article">
                            <h2 className="tokSubTitle">Listing tokens on an exchange</h2>
                            <p>
                                Once tokens are created and sold to investors, they need to be
                                listed on an exchange so investors can trade their tokens. There
                                are not many listing options out there, but the list keeps
                                growing.
                            </p>
                            <p>
                                Many of the most popular cryptocurrency exchanges are in the
                                process of obtaining regulatory approval to list security
                                tokens. Another option is to partner with an Alternative Trading
                                System (ATS): These are FINRA-registered institutions that
                                sometimes partner with tokenized security asset owners to list
                                security tokens and provide their investors with access to a
                                liquid secondary market. Our ATS partner is Templum Markets.
                            </p>
                            <p>
                                Keep in mind that a single token can be listed on multiple
                                exchanges.
                            </p>
                        </article>
                    </div>
                    <div className="tokWrapper">
                        <article className="text-article">
                            <h2 className="tokSubTitle">
                                How investors and owners benefit from tokenization
                            </h2>
                            <p>
                                Tokenization removes the middle man, making it easier and
                                cheaper for investors to buy/sell real estate and for
                                owners/developers to raise capital. Investors can trade tokens
                                almost instantly and for a very low fee (similar to stock market
                                trades). For owners, tokenization makes it possible to raise
                                capital without financial intermediaries to underwrite the
                                project.
                            </p>
                            <p>
                                Real estate has historically delivered attractive returns, but
                                it has high barriers to entry because the assets involved are so
                                expensive. Investors in tokenized real estate assets get the
                                best of both worlds: the high returns of{" "}
                                <a href={`${baseUrl}/tokenization-form`}>
                                    real estate investments
                                </a>{" "}
                                (even with a very small investment), and the liquidity of the
                                stock market.
                            </p>
                            <p>
                                It’s also important to note that because real estate tokens are
                                backed by real assets, they carry far less risk than
                                cryptocurrencies or ICOs, which are highly volatile and
                                speculative assets. What’s more, stabilization measures can be
                                put in place to ensure the value of the security token does not
                                deviate too far below the underlying net asset value (NAV) of
                                the property.
                            </p>
                        </article>
                        <img src={Future} alt="" className="mainImg" />
                        <article className="text-article">
                            <h2 className="tokSubTitle">
                                The future of commercial real estate tokenization
                            </h2>
                            <p>
                                The global real estate market is valued at US$228 trillion.
                                Before the tokenization of real estate, only accredited and
                                institutional investors had access to the most exciting
                                projects. But now asset owners and developers can market their projects globally
                                to retail investors as well as institutions.
                            </p>
                            <p>
                                Tokenization also brings much-needed liquidity and transparency
                                to a traditionally opaque industry. The ability to trade shares
                                in real assets, in real-time (the same way public companies are
                                traded in stock markets) should attract more investor attention
                                and unlock the potential for more ambitious and unique real
                                estate developments.
                            </p>
                            <p>
                                Of course, investors can already buy and sell real estate
                                investment trusts (REITs), but these often have high minimum
                                investments and represent a large portfolio of companies rather
                                than a single property or new development.
                            </p>
                            <p>
                                The tokenization of real estate is giving investors and owners
                                alike the freedom to raise/invest capital how they choose.
                                Tokenization will also impact other illiquid asset classes,
                                like private equity and venture capital.
                            </p>
                            <p>
                                Read more about the future of tokenization in this{" "}
                                <a
                                    href="https://medium.com/solidblock/why-tokenized-securities-will-be-even-more-disruptive-than-cryptocurrencies-and-icos-de7eeb807f72"
                                    rel="noreferrer"
                                    target="_blank"
                                >
                                    Medium article{" "}
                                </a>
                                written by predecessor, SolidBlock’s co founder Yuval Wirzberger.
                            </p>
                        </article>
                    </div>
                    <div className="purpleWrapper">
                        <article className="text-article">
                            <img src={Raise} alt="" className="mainImg" />
                            <h2 className="tokSubTitle">Ready to tokenize your asset?</h2>
                            <p>
                                DIBS Capital is a
                                <span className="text--bold">
                                    {" "}
                                    real estate tokenization platform
                                </span>{" "}
                                that uses blockchain technology and the Ethereum network to
                                create security tokens representing fractional interest in real
                                estate assets.
                            </p>
                            <p>
                                To get started with your first asset tokenization, please
                                complete our short introductory onboarding process and we’ll be
                                in touch with more details.
                            </p>
                            <p>
                                If you have questions about the process, you can{" "}
                                <a href={`${baseUrl}/contact`}>contact us</a> and
                                we’ll be happy to assist.
                            </p>
                            <a href={`${baseUrl}/tokenization-form`}>
                                <button className="tokStartBtn">
                                    Start Here
                                    <img src={BuyArrow} alt="" />
                                </button>
                            </a>
                        </article>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    )
}

export default IndexPage
